<div data-cy="add-user-dialog">
  <div mat-dialog-title class="header">{{ dialogAction }} Docusign Template</div>
  <mat-divider></mat-divider>
  <div mat-dialog-content>
    <form [formGroup]="templateForm" class="new-user-form">
      <mat-form-field class="full-width">
        <mat-label>Description</mat-label>
        <input
          formControlName="description"
          id="description"
          matInput
          data-cy="description-input"
          name="description"
          type="text" />
      </mat-form-field>
      <mat-form-field class="full-width">
        <mat-label>Template ID</mat-label>
        <input
          formControlName="templateId"
          id="templateId"
          matInput
          data-cy="templateId-input"
          name="templateId"
          type="text" />
      </mat-form-field>
    </form>
  </div>
  <div mat-dialog-actions>
    <button mat-stroked-button color="primary" mat-dialog-close data-cy="cancel-button">CANCEL</button>
    <button
      (click)="submitForm()"
      [disabled]="templateForm.invalid || templateForm.pristine"
      color="primary"
      data-cy="submit-button"
      mat-raised-button>
      {{ dialogAction }} Template
    </button>
  </div>
</div>
